module.exports = __webpack_public_path__ + "static/media/gorra (9).6cab7749.png";